import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { PlataformaJornadasDigitaisComponent } from './plataforma-jornadas-digitais.component';
import { CabecalhoDireitaModule } from '../../components/cabecalho/cabecalho-direita/cabecalho-direita.module';
import { JornadasModule } from '../../components/jornadas/jornadas.module';
import { BeneficioEsquerdaModule } from '../../components/beneficio/beneficio-esquerda/beneficio-esquerda.module';
import { BeneficioDireitaModule } from '../../components/beneficio/beneficio-direita/beneficio-direita.module';

@NgModule({
  declarations: [
    PlataformaJornadasDigitaisComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    CabecalhoDireitaModule,
    JornadasModule,
    BeneficioEsquerdaModule,
    BeneficioDireitaModule
  ],
  exports: [
    PlataformaJornadasDigitaisComponent
  ]
})

export class PlataformaJornadasDigitaisModule { }
